/**
 * Opens collage images in a full-size lightbox.
 */
(function () {
  if (window.__kdAltIntroLightboxBound) return;
  window.__kdAltIntroLightboxBound = true;

  var activeModal = null;
  var lastTrigger = null;

  function moveLightboxesToBody() {
    document.querySelectorAll('.kd-alt-intro-lightbox').forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveLightboxesToBody);
  } else {
    moveLightboxesToBody();
  }

  function openLightbox(modal, src, alt, trigger) {
    if (!modal || !src) return;
    var img = modal.querySelector('.kd-alt-intro-lightbox__image');
    if (!img) return;

    lastTrigger = trigger || null;
    activeModal = modal;
    img.src = src;
    img.alt = alt || '';
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('kd-alt-intro-lightbox-open');

    var closeBtn = modal.querySelector('[data-kd-image-lightbox-close].kd-alt-intro-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox(modal) {
    if (!modal) return;
    var img = modal.querySelector('.kd-alt-intro-lightbox__image');
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kd-alt-intro-lightbox-open');
    if (img) {
      img.removeAttribute('src');
      img.alt = '';
    }
    if (activeModal === modal) activeModal = null;
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-kd-image-lightbox-open]');
    if (openBtn) {
      e.preventDefault();
      var controlsId = openBtn.getAttribute('aria-controls');
      var modal = controlsId ? document.getElementById(controlsId) : null;
      var fullImage = openBtn.getAttribute('data-full-image');
      var altText = openBtn.getAttribute('aria-label') || '';
      openLightbox(modal, fullImage, altText, openBtn);
      return;
    }

    var closeHit = e.target.closest('[data-kd-image-lightbox-close]');
    if (closeHit) {
      e.preventDefault();
      closeLightbox(closeHit.closest('.kd-alt-intro-lightbox'));
      return;
    }

    var openLightboxEl = e.target.closest('.kd-alt-intro-lightbox.is-open');
    if (openLightboxEl && !e.target.closest('.kd-alt-intro-lightbox__image')) {
      e.preventDefault();
      closeLightbox(openLightboxEl);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kd-alt-intro-lightbox.is-open').forEach(closeLightbox);
  });

  document.addEventListener('shopify:section:load', moveLightboxesToBody);

  document.addEventListener('shopify:section:unload', function (ev) {
    var sid = ev.detail && ev.detail.sectionId;
    if (!sid) return;
    var modal = document.getElementById('kd-alt-intro-lightbox-' + sid);
    if (modal) {
      if (modal.classList.contains('is-open')) closeLightbox(modal);
      modal.remove();
    }
  });
})();
